import React from 'react';
import { Calendar } from 'lucide-react';

interface DefaultActiveInWeekProps {
  defaultActiveInWeek: boolean;
  setDefaultActiveInWeek: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
}

export const DefaultActiveInWeek: React.FC<DefaultActiveInWeekProps> = ({
  defaultActiveInWeek,
  setDefaultActiveInWeek,
  isLoading,
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
      <label className="flex items-center justify-between">
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={defaultActiveInWeek}
            onChange={(e) => setDefaultActiveInWeek(e.target.checked)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            disabled={isLoading}
          />
          <span className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
            <Calendar className="w-4 h-4 inline mr-2" />
            Default to Active in Week
          </span>
        </div>
      </label>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-2 ml-7">
        New tasks will automatically be set as active in the current week.
      </p>
    </div>
  );
};